import { Icon } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

const Container = styled.div`
  figure {
    outline: 0;

    &:hover,
    &:focus {
      outline: 0;
      border: 0;
    }
  }
  path:first-of-type {
    fill: #45586b;
  }
`

const FilterActionIcon = () => (
  <Container>
    <Icon nonFocusable iconName='FilterAction' icColor='_006BFF' />
  </Container>
)

export default FilterActionIcon
